import { render, staticRenderFns } from "./KnowledgeBaseArticle.vue?vue&type=template&id=4d7977d8&scoped=true&"
import script from "./KnowledgeBaseArticle.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseArticle.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseArticle.vue?vue&type=style&index=0&id=4d7977d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7977d8",
  null
  
)

export default component.exports